export const depositRatesHref = "https://www.avidiabank.com/personal/print/72";

// PDFs in public folder
export const transferDueToDivorce = "https://user.bendhsa.com/avidia/Transfer-Due-To-Divorce.pdf";
export const hsaDeathDistributionRquest = "https://user.bendhsa.com/avidia/HSA-Death-Distribution-Request.pdf";
export const iraToHsaTransfer = "https://user.bendhsa.com/avidia/IRA-to-HSA-Transfer.pdf";
export const revokeAuthorizedSigner = "https://user.bendhsa.com/avidia/Revoke-Authorized-Signer.pdf";
export const hsaBeneficiaryDesginationRequest = "https://user.bendhsa.com/avidia/HSA-Beneficiary-Designation-Request.pdf";
export const nameChangeRequest = "https://user.bendhsa.com/avidia/Name-Change-Request.pdf";
export const hsaRolloverRequest = "https://user.bendhsa.com/avidia/HSA-Rollover-Request.pdf";
export const hsaIndividualContributionForm = "https://user.bendhsa.com/avidia/HSA-Individual-Contribution-Form.pdf";
export const hsaAccountClosure = "https://user.bendhsa.com/avidia/HSA-Account-Closure.pdf";
export const employerContributionCorrection = "https://user.bendhsa.com/avidia/Employer-Contribution-Correction.pdf";
export const hsaCustodialTansferForm = "https://user.bendhsa.com/avidia/HSA-Custodial-Transfer-Form.pdf";
export const hsaDistributionReversal = "https://user.bendhsa.com/avidia/HSA-Distribution-Reversal.pdf";
